import React, { useEffect, useState } from "react";
import bloglist from "../../editable-stuff/blog";
const BlogPost = ({ match }) => {
  const { id } = match.params;
  const post = bloglist[id];

  return (
    <p>hello</p>
  );
};

export default BlogPost;
